import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { LP1Page } from './pages/LP1Page';
import { LP2Page } from './pages/LP2Page';
function MetaPixel() {
  useEffect(() => {
    // Meta Pixel Code
    const f = window as any;
    if (f.fbq) return;
    const n: any = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const t = document.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const s = document.getElementsByTagName('script')[0];
    s?.parentNode?.insertBefore(t, s);
    f.fbq('init', '1398555731600742');
    f.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-3">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1398555731600742&ev=PageView&noscript=1" alt="" data-id="element-4" />
    </noscript>;
}
export function AppRouter() {
  return <BrowserRouter data-id="element-5">
      <MetaPixel data-id="element-6" />
      <Routes data-id="element-7">
        <Route path="/" element={<App data-id="element-9" />} data-id="element-8" />
        <Route path="/lp1" element={<LP1Page data-id="element-11" />} data-id="element-10" />
        <Route path="/lp2" element={<LP2Page data-id="element-13" />} data-id="element-12" />
      </Routes>
    </BrowserRouter>;
}